import { makeStyles } from "components/providers/makeStyles";
import { TeamMembersAthlete } from "./TeamMembersAthlete";
import { TeamMembersPlaceholder } from "./TeamMembersPlaceholder";
import classnames from "classnames";

const useStyles = makeStyles((theme) => ({
    cell: {
        display: "grid",
        columnGap: theme.spacing(1),
        alignItems: "center",
        flex: 1,
    },
    placeholder: {
        gridTemplateColumns: `${theme.spacing(5)} 1fr`,
    },
    athlete: {
        gridTemplateColumns: `${theme.spacing(5)} 1fr auto`,
    },
}));

export const TeamMembersRow = ({
    index,
    member,
    onAthleteRemoved,
    onUpdateTeamMemberRole,
    teamRoles,
    assignedRoles,
    disabled,
    renderTeamMembersSelector,
}) => {
    const classes = useStyles();

    return (
        <div
            className={classnames(
                classes.cell,
                member && onAthleteRemoved
                    ? classes.athlete
                    : classes.placeholder,
            )}
        >
            {member ? (
                <TeamMembersAthlete
                    index={index}
                    athlete={member.athlete}
                    teamRoleName={member.teamRoleName}
                    onAthleteRemoved={onAthleteRemoved}
                    onUpdateTeamMemberRole={onUpdateTeamMemberRole}
                    teamRoles={teamRoles}
                    assignedRoles={assignedRoles}
                    disabled={disabled}
                />
            ) : (
                <TeamMembersPlaceholder
                    index={index}
                    renderTeamMembersSelector={renderTeamMembersSelector}
                />
            )}
        </div>
    );
};
